import { CONNECTION_KIND_BADGE_CLASS, CONNECTION_KIND_LABELS, CONNECTION_KIND_SHORT, type ConnectionKind } from '../../types/network';

/**
 * Anschlussart badge (details header, table cell, search result). Households are the default
 * and stay quiet unless `showHousehold` is set.
 */
export function ConnectionKindBadge({ kind, showHousehold = false, short = false, className = '' }: {
  kind: ConnectionKind;
  showHousehold?: boolean;
  short?: boolean;
  className?: string;
}) {
  if (kind === 'household' && !showHousehold) return null;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide ${CONNECTION_KIND_BADGE_CLASS[kind]} ${className}`}
      title={`Anschlussart: ${CONNECTION_KIND_LABELS[kind]}`}
    >
      {short ? CONNECTION_KIND_SHORT[kind] : CONNECTION_KIND_LABELS[kind]}
    </span>
  );
}
